import type { PublicConfig } from '../shared/types';

interface SettingsPanelProps {
  config: PublicConfig;
  onChange: (next: PublicConfig) => void;
  onSave: () => void;
  busy?: boolean;
}

export function SettingsPanel({ config, onChange, onSave, busy }: SettingsPanelProps) {
  return (
    <div className="grid gap-3">
      <p className="text-xs font-medium text-slate-500">邮件提醒设置</p>

      <div className="grid gap-3 sm:grid-cols-2">
        <Field label="邮件提醒">
          <select
            value={String(config.mail_enabled)}
            onChange={(e) => onChange({ ...config, mail_enabled: e.target.value === 'true' })}
            className={inputCls}
          >
            <option value="true">开启</option>
            <option value="false">关闭</option>
          </select>
        </Field>

        <Field label="发送时间（北京时间）">
          <input
            type="time"
            value={config.mail_time}
            onChange={(e) => onChange({ ...config, mail_time: e.target.value })}
            className={inputCls}
          />
        </Field>

        <Field label="接收邮箱">
          <input
            type="email"
            value={config.mail_to}
            onChange={(e) => onChange({ ...config, mail_to: e.target.value })}
            placeholder="you@example.com"
            className={inputCls}
          />
        </Field>

        <Field label="邮件服务">
          <select
            value={config.mail_provider}
            onChange={(e) => onChange({ ...config, mail_provider: e.target.value as PublicConfig['mail_provider'] })}
            className={inputCls}
          >
            <option value="resend">Resend</option>
            <option value="brevo">Brevo</option>
          </select>
        </Field>

        <Field label="发件人" className="sm:col-span-2">
          <input
            value={config.mail_from}
            onChange={(e) => onChange({ ...config, mail_from: e.target.value })}
            placeholder="课表 <no-reply@example.com>"
            className={inputCls}
          />
        </Field>
      </div>

      <div className="flex items-center justify-end gap-3">
        <span className="text-xs text-slate-400">API Key 保留在 Worker Secret 中</span>
        <button
          type="button"
          onClick={onSave}
          disabled={busy}
          className="h-9 rounded-xl bg-slate-800 px-4 text-sm font-medium text-white hover:bg-slate-900 disabled:opacity-50 transition"
        >
          {busy ? '保存中…' : '保存'}
        </button>
      </div>
    </div>
  );
}

const inputCls = 'h-9 w-full rounded-lg border border-slate-200 bg-slate-50 px-3 text-sm text-slate-800 outline-none focus:border-blue-400 focus:bg-white placeholder:text-slate-400';

function Field({ label, children, className }: { label: string; children: React.ReactNode; className?: string }) {
  return (
    <div className={['flex flex-col gap-1', className].filter(Boolean).join(' ')}>
      <span className="text-xs text-slate-500">{label}</span>
      {children}
    </div>
  );
}
